<template>
  <v-app>
    <router-view></router-view>

    <!-- Loading overlay -->
    <v-overlay
      :model-value="loading"
      class="align-center justify-center"
      persistent
    >
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <!-- Global snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template #actions>
        <v-btn
          variant="text"
          @click="snackbar.show = false"
        >
          Đóng
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'App',

  setup() {
    const store = useStore()
    const router = useRouter()
    const loading = ref(true)

    const snackbar = computed(() => store.state.app.snackbar)

    const initializeApp = async () => {
      try {
        // Restore session from localStorage
        const token = localStorage.getItem('access_token')
        if (token) {
          await store.dispatch('auth/restoreSession')
        }

        // Initialize other required data
        await Promise.all([
          store.dispatch('settings/fetchSettings')
        ])

      } catch (error) {
        console.error('Error initializing app:', error)
        if (error.response?.status === 401) {
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
          router.push('/login')
        }
      } finally {
        loading.value = false
      }
    }

    // Handle session timeout
    let sessionTimeout = null
    const startSessionTimer = () => {
      if (sessionTimeout) {
        clearTimeout(sessionTimeout)
      }
      
      const timeout = process.env.VUE_APP_SESSION_TIMEOUT || 30
      sessionTimeout = setTimeout(() => {
        store.dispatch('auth/logout')
        router.push('/login')
        store.dispatch('app/showError', 'Phiên làm việc đã hết hạn')
      }, timeout * 60 * 1000)
    }

    // Reset timer on user interaction
    const resetSessionTimer = () => {
      if (store.getters['auth/isAuthenticated']) {
        startSessionTimer()
      }
    }

    onMounted(() => {
      document.addEventListener('click', resetSessionTimer)
      document.addEventListener('keypress', resetSessionTimer)
      document.addEventListener('mousemove', resetSessionTimer)
      initializeApp()

      // Cleanup
      return () => {
        document.removeEventListener('click', resetSessionTimer)
        document.removeEventListener('keypress', resetSessionTimer)
        document.removeEventListener('mousemove', resetSessionTimer)
        if (sessionTimeout) {
          clearTimeout(sessionTimeout)
        }
      }
    })

    return {
      loading,
      snackbar
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/styles/index';

/* Additional app-specific styles */
.v-application {
  font-family: var(--font-family-base);
  
  .v-main {
    background-color: var(--v-background);
  }
}
</style>